/*
  作者：he.zhikai
  时间：2017-10-16
  描述：采编中心-I我、报纸、网站、微信渠道新闻稿编辑器按钮工厂
*/
"use strict";
angular.module("util.ueditorServiceBtnModule", []).factory('ueditorBtnService', ["ueditorService", "$q", "modalDialog", "localStorageService",
    function (ueditorService, $q, modalDialog, localStorageService) {
        return {
            /**
             * [insertImage description] 插入图片
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            insertImage: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ""
                };
                UE.registerUI("插入图片", function (editor, uiName) { //插入组件功能
                    //注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () { }
                    });
                    btn.obj = new UE.ui.Button({
                        //按钮的名字
                        name: "插入图片",
                        //提示
                        title: "插入图片",
                        //需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-position: -726px -78px;',
                        //点击时执行的命令
                        onclick: function () {
                            ueditorService.basicUploadPic().then(function (data) {
                                var dom = document.createElement("div");
                                dom.innerHTML = data;
                                // var index = 0;
                                ue.execCommand("inserthtml", dom.innerHTML);
                                ue.fireEvent("contentChange");
                                // var $imgs = $(dom).find("img");
                                // $imgs.each(function(i) {
                                //     var self = this;
                                //     this.onload = function() {
                                //         if (this.width > 550)
                                //             $(this).attr("width", "550");
                                //         index++;
                                //         if (index === $imgs.length) {
                                //             ue.execCommand("inserthtml", dom.innerHTML);
                                //             ue.fireEvent("contentChange");
                                //         }
                                //     };
                                // });
                            });
                        }
                    });
                    defer.resolve(btn);
                    return btn.obj;
                });
                return defer.promise;
            },
            /**
             * [pageBreak description] 插入分页
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            pageBreak: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ""
                };
                UE.registerUI('pagebreak', function (editor, uiName) {
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            //ue.execCommand('insertHtml', '<trs_page_separator pagetitle="" firstpagetitle=""/>');
                            ue.execCommand('insertHtml', '<hr ispageseparator="true"/>');
                            ue.fireEvent('contentchange');
                        }
                    });
                    btn.obj = new UE.ui.Button({
                        name: "pagebreak",
                        title: "插入分页",
                        cssRules: 'background-position: -460px -40px;',
                        onclick: function () {
                            editor.execCommand(uiName);
                        }
                    });
                    if (scope.type === 'website') {
                        defer.resolve(btn);
                        return btn.obj;
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            },
            /**
             * [recoverLocalVersion description] 恢复本地版本
             * @param  {[type]} UE    [description] 编辑器对象
             * @param  {[type]} scope [description] 编辑器指令作用域
             * @param  {[type]} ue    [description] 编辑器对象
             * @param  {[type]} i     [description] 按钮序号
             * @return {[type]}       [description]
             */
            recoverLocalVersion: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ""
                };
                UE.registerUI('button', function (editor, uiName) {
                    //注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            var flag = false;
                            var content = "";
                            var storage = localStorageService.get("ueLocalVersion");
                            if (storage !== null) {
                                for (var i = 0; i < storage.length; i++) {
                                    if (storage[i].ID === scope.list.id + "" && (!storage[i].DOCTYPE || storage[i].DOCTYPE === scope.doctype)) {
                                        content = storage[i].CONTENT;
                                        flag = true;
                                        break;
                                    }
                                }
                            }
                            if (flag) {
                                modalDialog.confirmModal("恢复本地版本?", "确定要恢复到该版本的本地版本？", function () {
                                    ue.setContent(content);
                                });
                            } else {
                                modalDialog.alertType("您本地没有本地版本", "", "error", false);
                            }
                        }
                    });
                    //创建一个button
                    btn.obj = new UE.ui.Button({
                        //按钮的名字
                        name: "恢复本地版本",
                        //提示
                        title: "恢复本地版本",
                        //需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-position: -559px -39px;',
                        //点击时执行的命令
                        onclick: function () {
                            //这里可以不用执行命令,做你自己的操作也可
                            editor.execCommand(uiName);
                        }
                    });
                    defer.resolve(btn);
                    //因为你是添加button,所以需要返回这个button
                    return btn.obj;
                }); /*index 指定添加到工具栏上的那个位置，默认时追加到最后,editorId 指定这个UI是那个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮*/
                return defer.promise;
            },
            /**
             * [insertVideo description] 插入视频
             * @return {[type]} [description]
             */
            insertVideo: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ""
                };
                //插入视频开始 ---start
                UE.registerUI('插入视频', function (editor, uiName) {
                    // debugger;
                    //注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            trsUploadAVNewService.openVideoModal(metadataId, type, chnldocId).then(function (data) {
                                for (var i = 0; i < data.length; i++) {
                                    if (data[i].videoHtml !== undefined) {
                                        var dom = document.createElement("div");
                                        dom.innerHTML = data[i].videoHtml;
                                        ue.execCommand("inserthtml", dom.innerHTML);
                                        ue.fireEvent("contentChange");
                                    }
                                }
                            });
                        }
                    });

                    //创建一个button
                    btn.obj = new UE.ui.Button({

                        //按钮的名字
                        name: "插入视频",
                        //提示
                        title: "插入视频",
                        //需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-position: -320px -20px;',
                        //点击时执行的命令
                        onclick: function () {
                            ueditorService.insertVideo().then(function (data) {
                                var videoHtml = "<p style='text-align: center;'><img class='trsresize' style='cursor: pointer;max-width:550px' videoId=" + data.videoid + " src=" + data.imgUrl + " filename=" + data.filename + " filesize=" + data.size + " resourcetype=" + data.type + " /></p><p><br/></p>";
                                ue.execCommand("inserthtml", videoHtml);
                                ue.fireEvent("contentChange");
                                ueditorService.drawVideoMark(true,true);
                            });
                        }
                    });
                    defer.resolve(btn);
                    //因为你是添加button,所以需要返回这个button
                    return btn.obj;
                });
                return defer.promise;
                //插入视频结束 ---end
            },
            /**
             * [insertAudio description] 插入音频
             * @return {[type]} [description]
             */
            insertAudio: function (UE, scope, ue, i) {
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ""
                };
                UE.registerUI('插入音频', function (editor, uiName) {
                    //注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            trsUploadAVNewService.openAudioModal(metadataId, type, chnldicId).then(function (data) {
                                for (var i = 0; i < data.length; i++) {
                                    if (data[i].audioHtml !== undefined) {
                                        var dom = document.createElement("div");
                                        dom.innerHTML = data[i].audioHtml;
                                        ue.execCommand("inserthtml", dom.innerHTML);
                                        ue.fireEvent("contentChange");
                                    }
                                }
                            });
                        }
                    });

                    //创建一个button
                    btn.obj = new UE.ui.Button({
                        //按钮的名字
                        name: "插入音频",
                        //提示
                        title: "插入音频",
                        //需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-position: -20px -40px;',
                        //点击时执行的命令
                        onclick: function () {
                            ueditorService.insertAudio().then(function (data) {
                                console.log(data);
                                // var audioHtml = "<img audioId="+data.id+"  src="+data.imgUrl+" width='586px' style='cursor: pointer;'/>"
                                var audioHtml = "<p><audio  controls='controls' src=" + data.audioUrl + " width='586px' style='cursor: pointer;'/></<p>"
                                ue.execCommand("inserthtml", audioHtml);
                                ue.fireEvent("contentChange");
                            })
                        }
                    });
                    defer.resolve(btn);
                    //因为你是添加button,所以需要返回这个button
                    return btn.obj;
                });
                return defer.promise;
            },
            insertword: function (UE, scope, ue, i) {
                // debugger;
                var defer = $q.defer();
                var btn = {
                    index: i,
                    obj: ""
                };
                UE.registerUI('插入word', function (editor, uiName) {
                    //注册按钮执行时的command命令，使用命令默认就会带有回退操作
                    editor.registerCommand(uiName, {
                        execCommand: function () {
                            trsUploadAVNewService.openAudioModal(metadataId, type, chnldicId).then(function (data) {
                                for (var i = 0; i < data.length; i++) {
                                    if (data[i].audioHtml !== undefined) {
                                        var dom = document.createElement("div");
                                        dom.innerHTML = data[i].audioHtml;
                                        ue.execCommand("inserthtml", dom.innerHTML);
                                        ue.fireEvent("contentChange");
                                    }
                                }
                            });
                        }
                    });

                    //创建一个button
                    btn.obj = new UE.ui.Button({
                        //按钮的名字
                        name: "插入word",
                        //提示
                        title: "插入word",
                        //需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                        cssRules: 'background-position: -302px -40px;',
                        //点击时执行的命令
                        onclick: function () {
                            ueditorService.insertword().then(function (data) {
                                console.log(data);
                                var audioHtml = "<img audioId=" + data.id + "  src=" + data.imgUrl + " width='586px' style='cursor: pointer;'/>"
                                ue.execCommand("inserthtml", audioHtml);
                                ue.fireEvent("contentChange");
                            })
                        }
                    });
                    defer.resolve(btn);
                    //因为你是添加button,所以需要返回这个button
                    return btn.obj;
                });
                return defer.promise;
            }
        };
    }
]);
